import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_on2vzm5lxj: FaireBrandEntity = {
  token: "b_on2vzm5lxj",
  type: "brand",
  name: "Two Sisters Spa",
  avatarUrl:
    "https://cdn.faire.com/fastly/cbbfbfee41e20b4ca8f5eebdec51920ddc73fd0c4693cebbb65ebc4276249c08.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/6db6edbcda5496e5a5cb8f29310460a1cfdb93d46cdabb48d009bd984d15b51a.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/cbbfbfee41e20b4ca8f5eebdec51920ddc73fd0c4693cebbb65ebc4276249c08.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/6db6edbcda5496e5a5cb8f29310460a1cfdb93d46cdabb48d009bd984d15b51a.jpeg",
  location: "Eden Prairie, MN, USA",
  minimumOrderDollars: 0,
  rating: 5,
  reviewCount: 378,
  isTopShop: true,
  isInsider: true,
  description:
    "ABOUT TWO SISTERS \n\nWe are a team of moms whose mission is to create #abetterbathtime. Two Sisters is more than just a brand; it's a heartfelt journey that began with a mother's simple wish: to turn her children’s bath time into a safe, fun, and magical experience.\n\nTwo Sisters continues to bring joy to bath time with its creative, safe, and kid-friendly products. Known for crafting bath bombs that turn an ordinary bath into a magical experience, we focus on delivering quality, safety, and fun for children. We have also expanded to offer indulgent products for women too. With a dedication to quality, safety, and sensory delight, Two Sisters creates bath bombs that turn a regular bath into a pampering, aromatic escape.\n\nOur Values: Quality, Safety, and Creativity\nEvery Two Sisters product is proudly made in the USA, using only premium ingredients that are gentle, safe, and effective. We rigorously test each batch to ensure it meets our high standards for safety and performance. Our bath bombs are free from harsh chemicals, parabens, and phthalates, ensuring a worry-free experience for families.\n\nWe believe in the power of imagination and creativity. That’s why our products are designed to surprise and delight.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:16.575Z",
    importedBy: "entity-db-cli",
  },
};
